export function apiRequestObject(searchTerm) {
  return {
    "from": 0,
    "size": 30,
    "sort": [
      {
        "_score": {
          "order": "desc"
        }
      }
    ],
    "query": {
      "bool": {
        "should": [
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^2",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^2",
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^2",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^2",
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^2",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^2",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      }
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "article"
                  }
                }
              ]
            }
          },
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "attachments.attachment.content^1",
                            "terms.post_tag.name^1",
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          fields: [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "attachments.attachment.content^1",
                            "terms.post_tag.name^1",
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "attachments.attachment.content^1",
                            "terms.post_tag.name^1",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      },
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "attachment"
                  }
                }
              ]
            }
          },
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "first_name^1",
                            "middle_name^1",
                            "last_name^1",
                            "affiliation^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "first_name^1",
                            "middle_name^1",
                            "last_name^1",
                            "affiliation^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "first_name^1",
                            "middle_name^1",
                            "last_name^1",
                            "affiliation^1",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      }
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "staff"
                  }
                }
              ]
            }
          },
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      }
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "collection"
                  }
                }
              ]
            }
          },
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "chapters_0_chapter_title^1",
                            "chapters_1_chapter_title^1",
                            "chapters_2_chapter_title^1",
                            "chapters_3_chapter_title^1",
                            "chapters_4_chapter_title^1",
                            "chapters_5_chapter_title^1",
                            "chapters_6_chapter_title^1",
                            "chapters_7_chapter_title^1",
                            "chapters_8_chapter_title^1",
                            "chapters_9_chapter_title^1",
                            "chapters_10_chapter_title^1",
                            "chapters_0_chapter_text^1",
                            "chapters_1_chapter_text^1",
                            "chapters_2_chapter_text^1",
                            "chapters_3_chapter_text^1",
                            "chapters_4_chapter_text^1",
                            "chapters_5_chapter_text^1",
                            "chapters_6_chapter_text^1",
                            "chapters_7_chapter_text^1",
                            "chapters_8_chapter_text^1",
                            "chapters_9_chapter_text^1",
                            "chapters_10_chapter_text^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "chapters_0_chapter_title^1",
                            "chapters_1_chapter_title^1",
                            "chapters_2_chapter_title^1",
                            "chapters_3_chapter_title^1",
                            "chapters_4_chapter_title^1",
                            "chapters_5_chapter_title^1",
                            "chapters_6_chapter_title^1",
                            "chapters_7_chapter_title^1",
                            "chapters_8_chapter_title^1",
                            "chapters_9_chapter_title^1",
                            "chapters_10_chapter_title^1",
                            "chapters_0_chapter_text^1",
                            "chapters_1_chapter_text^1",
                            "chapters_2_chapter_text^1",
                            "chapters_3_chapter_text^1",
                            "chapters_4_chapter_text^1",
                            "chapters_5_chapter_text^1",
                            "chapters_6_chapter_text^1",
                            "chapters_7_chapter_text^1",
                            "chapters_8_chapter_text^1",
                            "chapters_9_chapter_text^1",
                            "chapters_10_chapter_text^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "terms.post_tag.name^1",
                            "blurb^1",
                            "description^1",
                            "chapters_0_chapter_title^1",
                            "chapters_1_chapter_title^1",
                            "chapters_2_chapter_title^1",
                            "chapters_3_chapter_title^1",
                            "chapters_4_chapter_title^1",
                            "chapters_5_chapter_title^1",
                            "chapters_6_chapter_title^1",
                            "chapters_7_chapter_title^1",
                            "chapters_8_chapter_title^1",
                            "chapters_9_chapter_title^1",
                            "chapters_10_chapter_title^1",
                            "chapters_0_chapter_text^1",
                            "chapters_1_chapter_text^1",
                            "chapters_2_chapter_text^1",
                            "chapters_3_chapter_text^1",
                            "chapters_4_chapter_text^1",
                            "chapters_5_chapter_text^1",
                            "chapters_6_chapter_text^1",
                            "chapters_7_chapter_text^1",
                            "chapters_8_chapter_text^1",
                            "chapters_9_chapter_text^1",
                            "chapters_10_chapter_text^1",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      }
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "exhibition"
                  }
                }
              ]
            }
          },
          {
            "bool": {
              "must": [
                {
                  "bool": {
                    "should": [
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "type": "phrase",
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "objective^1",
                            "additional_detail^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 4
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "objective^1",
                            "additional_detail^1",
                            "terms.ep_custom_result.name^9999"
                          ],
                          "boost": 2,
                          "fuzziness": 0,
                          "operator": "and"
                        }
                      },
                      {
                        "multi_match": {
                          "query": searchTerm,
                          "fields": [
                            "post_title^1",
                            "post_excerpt^1",
                            "post_content^1",
                            "objective^1",
                            "additional_detail^1",
                            "post_title.suggest^1"
                          ],
                          "fuzziness": "auto"
                        }
                      }
                    ]
                  }
                }
              ],
              "filter": [
                {
                  "match": {
                    "post_type.raw": "georgia-standard"
                  }
                }
              ]
            }
          }
        ]
      }
    },
    "post_filter": {
      "bool": {
        "must": [
          {
            "terms": {
              "post_type.raw": [
                "article",
                "attachment",
                "staff",
                "collection",
                "exhibition",
                "georgia-standard"
              ]
            }
          },
          {
            "terms": {
              "post_status": [
                "publish",
                "acf-disabled",
                "inherit"
              ]
            }
          }
        ]
      }
    }
  };
}